import React from 'react'
import { mediaVariants } from '@web/modules/message-preview/styles'
import { ChatSource, ComponentMessageMediaVO } from '@repo/types'
import { MediaTypeVO } from '@repo/types/src/types/MediaTypeVO'
import { MEDIA_TYPES } from '@repo/network'
import { Button } from '@tecsinapse/cortex-react'
import MediaTypeIcon from '@web/modules/core/components/MediaTypeIcon'

interface MediaProps {
  source: ChatSource
  mediaType: MediaTypeVO
  mediaUrl?: string | null
  media?: ComponentMessageMediaVO | null
}

const { container, image, video, documentContainer, document } = mediaVariants()

const Media = ({ source, mediaType, mediaUrl, media }: MediaProps) => {
  if (!mediaUrl) {
    return (
      <div className={container()}>
        <MediaTypeIcon mediaType={mediaType.icon} />
      </div>
    )
  }

  return (
    <>
      {MEDIA_TYPES.MEDIA_IMAGE === mediaType && (
        <img
          className={image({ source })}
          src={mediaUrl}
          alt={media?.name}
          onClick={() => window.open(mediaUrl, '_blank')}
        />
      )}
      {MEDIA_TYPES.MEDIA_VIDEO === mediaType && (
        <video
          className={video({ source })}
          src={mediaUrl}
          controls
        />
      )}
      {MEDIA_TYPES.MEDIA_AUDIO === mediaType && (
        <audio
          className={video({ source })}
          src={mediaUrl}
          controls
        />
      )}
      {MEDIA_TYPES.MEDIA_DOCUMENT === mediaType && (
        <div className={documentContainer()}>
          <iframe
            className={document({ source })}
            src={mediaUrl}
          />
          <Button
            variants={{ size: 'small' }}
            onClick={() => window.open(mediaUrl, '_blank')}
          >
            <p>Download</p>
          </Button>
        </div>
      )}
    </>
  )
}

export default Media
